// Add your JS customizations here

document.addEventListener('DOMContentLoaded', function () {

    const form = document.getElementById('imperial-form');
    if (!form) return;

    const inputs = form.querySelectorAll('input, select');

    let bmiTimeout;

    console.log(Array.from(inputs).map(el => [el.id, el]));

	inputs.forEach(el => {

	    el.addEventListener('input', triggerCalc);
	    el.addEventListener('change', triggerCalc);

	});

	function triggerCalc() {
	    clearTimeout(bmiTimeout);
	    bmiTimeout = setTimeout(calculateImperialBMI, 50);
	}

    function get(val) {
        return form.querySelector(val);
    }

    function getCategory(bmi, ethnicity) {
        if (ethnicity === 'higher-risk') {
            if (bmi < 18.5) return 'Underweight';
            if (bmi < 23) return 'Healthy weight';
            if (bmi < 27.5) return 'Increased risk';
            return 'High risk';
        }

        if (bmi < 18.5) return 'Underweight';
        if (bmi < 25) return 'Healthy weight';
        if (bmi < 30) return 'Overweight';
        return 'Obese';
    }

    function calculateImperialBMI() {

	    const stone = parseFloat(get('#weight-stone').value) || 0;
	    const pounds = parseFloat(get('#weight-pounds').value) || 0;

	    const feet = parseFloat(get('#height-feet').value) || 0;
	    const inches = parseFloat(get('#height-inches').value) || 0;

	    const ethnicity = get('#ethnicity').value;

	    const totalPounds = (stone * 14) + pounds;
	    const totalInches = (feet * 12) + inches;

	    const bmiField = document.getElementById('bmi-result');
	    const messageField = document.getElementById('message-result');
	    const getStarted = document.querySelector('.get_started_imperial');

	    // ✅ ONLY real validation rules
	    if (!ethnicity || totalInches === 0) {
	        bmiField.value = '';
	        messageField.textContent = '';
	        if (getStarted) getStarted.classList.remove('active');
	        return;
	    }

	    const bmi = (totalPounds / (totalInches * totalInches)) * 703;

	    const category = getCategory(bmi, ethnicity);

	    bmiField.value = `Your BMI is: ${bmi.toFixed(1)} (${category})`;

	    if (bmi >= 30) {
	    	messageField.classList.add('text-primary');
	        messageField.textContent =
	            "You may be eligible for weight loss treatment";

	        if (getStarted) {
	            getStarted.classList.add('active');
	        }

	    } else {
	    	messageField.classList.remove('text-primary');
	        messageField.textContent =
	            "Sorry, your BMI is too low to make you an appropriate candidate for one of our treatments";

	        if (getStarted) {
	            getStarted.classList.remove('active');
	        }
	    }
	}

});



document.addEventListener('DOMContentLoaded', function () {

    const form = document.getElementById('metric-form');
    if (!form) return;

    const inputs = form.querySelectorAll('input, select');

    let bmiTimeout;

    console.log(Array.from(inputs).map(el => [el.id, el]));

    inputs.forEach(el => {

	    el.addEventListener('input', triggerCalc);
	    el.addEventListener('change', triggerCalc);

	});

	function triggerCalc() {
	    clearTimeout(bmiTimeout);
	    bmiTimeout = setTimeout(calculateMetricBMI, 50);
	}

    function get(val) {
        return form.querySelector(val);
    }

    function getCategory(bmi, ethnicity) {
        if (ethnicity === 'higher-risk') {
            if (bmi < 18.5) return 'Underweight';
            if (bmi < 23) return 'Healthy weight';
            if (bmi < 27.5) return 'Increased risk';
            return 'High risk';
        }

        if (bmi < 18.5) return 'Underweight';
        if (bmi < 25) return 'Healthy weight';
        if (bmi < 30) return 'Overweight';
        return 'Obese';
    }

    function calculateMetricBMI() {

        const weight = parseFloat(get('#metric-weight').value) || 0;
        const heightCm = parseFloat(get('#metric-height').value) || 0;
        const ethnicity = get('#metric-ethnicity').value;
        const getStarted = document.querySelector('.get_started_metric');

        const bmiField = document.getElementById('metric-bmi-result');
        const messageField = document.getElementById('metric-message-result');

        if (!weight || !heightCm || !ethnicity) {
            bmiField.value = '';
            messageField.textContent = '';
            if (getStarted) getStarted.classList.remove('active');
            return;
        }

        const bmi = weight / Math.pow(heightCm / 100, 2);

        const category = getCategory(bmi, ethnicity);

        bmiField.value = `Your BMI is: ${bmi.toFixed(1)} (${category})`;

	    if (bmi >= 30) {
	    	messageField.classList.add('text-primary');
	        messageField.textContent =
	            "You may be eligible for weight loss treatment";

	        if (getStarted) {
	            getStarted.classList.add('active');
	        }

	    } else {
	    	messageField.classList.remove('text-primary');
	        messageField.textContent =
	            "Sorry, your BMI is too low to make you an appropriate candidate for one of our treatments";

	        if (getStarted) {
	            getStarted.classList.remove('active');
	        }
	    }
    }

});

document.addEventListener('DOMContentLoaded', function () {
	if (window.innerWidth > 991.98) {
		AOS.init({
			duration: 800,   // Animation duration in ms
		});
	}

	const navToggler = document.getElementById('nav_toggler');
	if (navToggler) {
		navToggler.addEventListener('click', function () {
			const menu = document.getElementById('se_mobile');
			const toggle = document.getElementById('nav_toggler');
			const start = document.getElementById('fixed_start');
			document.body.classList.toggle('menu_open');
			if (menu) menu.classList.toggle('active');
			if (toggle) toggle.classList.toggle('active');
			if (start) start.classList.toggle('menu_open');
		});
	}

	const navTargets = {
		treatments: '.view_treatments',
		about: '.view_about',
		programme: '.view_programme',
		hub: '.view_hub'
	};

	function closeNavDropdowns(exceptToggle = null) {
		const exceptItem = exceptToggle?.closest('.dropdown');

		document.querySelectorAll('#main_nav_menu .dropdown.show').forEach(item => {
			if (item !== exceptItem) item.classList.remove('show');
		});

		document.querySelectorAll('#main_nav_menu .dropdown-menu.show').forEach(menu => {
			if (!exceptItem?.contains(menu)) menu.classList.remove('show');
		});

		document.querySelectorAll('#main_nav_menu [aria-expanded="true"]').forEach(toggle => {
			if (toggle !== exceptToggle) toggle.setAttribute('aria-expanded', 'false');
		});
	}

	function openDropdown(name) {
		const toggle = [...document.querySelectorAll('#main_nav_menu .dropdown-toggle')]
			.find(item => item.textContent.trim().toLowerCase().includes(name));

		if (!toggle) return;

		const dropdown = toggle.closest('.dropdown');
		const menu = dropdown?.querySelector('.dropdown-menu');

		closeNavDropdowns(toggle);

		dropdown?.classList.add('show');
		menu?.classList.add('show');
		toggle.setAttribute('aria-expanded', 'true');
	}

	document.querySelectorAll('#main_nav_menu .dropdown-toggle')
	.forEach(toggle => {
		toggle.addEventListener('click', () => closeNavDropdowns(toggle));
	});

	Object.entries(navTargets).forEach(([name, selector]) => {

		document.querySelectorAll(selector).forEach(button => {

			button.addEventListener('click', event => {

				const mobileMenu = document.getElementById('se_mobile');

				if (window.innerWidth <= 991.98) {
					event.preventDefault();
					event.stopPropagation();

					document.body.classList.add('menu_open');
					mobileMenu?.classList.add('active');
					navToggler?.classList.add('active');

					return;
				}

				event.preventDefault();
				event.stopPropagation();

				openDropdown(name);
			});

		});

	});

	document.body.matchHeight();

	// testimonials carousel

    const testimonials = document.querySelectorAll('#testimonials');

    testimonials.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        //const prevBtn  = wrapper.querySelector('.testimonial_prev');
        const nextBtn  = wrapper.querySelector('.testimonial_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 2;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        //if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    // accreditations carousel

    const accreditations = document.querySelectorAll('#accreditations');

    accreditations.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        //const prevBtn  = wrapper.querySelector('.testimonial_prev');
        //const nextBtn  = wrapper.querySelector('.testimonial_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 2;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        autoplay: true,
	        interval: 4000,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1, type: 'fade', rewind: true },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        //if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        //if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    const seo_accreditations = document.querySelectorAll('#seo_accreditations');

    seo_accreditations.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        //const prevBtn  = wrapper.querySelector('.testimonial_prev');
        //const nextBtn  = wrapper.querySelector('.testimonial_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 4;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        autoplay: true,
	        interval: 4000,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1, type: 'fade', rewind: true },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        //if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        //if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    const other_case_studies = document.querySelectorAll('#other_case_studies');

    other_case_studies.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.cs_prev');
        const nextBtn  = wrapper.querySelector('.cs_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 2;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        autoplay: true,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    const related_treatments = document.querySelectorAll('#related_treatments');

    function updateTreatmentHeights(wrapper) {
		const elements = wrapper.querySelectorAll('.text_content[data-mh="rt_desc"]');

		if (!elements.length) return;

		// Reset heights first
		elements.forEach(el => {
			el.style.height = 'auto';
		});

		// Find tallest element across ALL slides
		let maxHeight = 0;

		elements.forEach(el => {
			maxHeight = Math.max(maxHeight, el.offsetHeight);
		});

		// Apply tallest height to all
		elements.forEach(el => {
			el.style.height = `${maxHeight}px`;
		});
	}

    related_treatments.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const relprevBtn  = wrapper.querySelector('.treatment_prev');
        const relnextBtn  = wrapper.querySelector('.treatment_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 2;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        autoplay: true,
	        interval: 6000,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1, rewind: true },
	        },
	    });

	    splide.on('mounted', () => {
	    	updateTreatmentHeights(wrapper);
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.on('moved', () => {
			updateTreatmentHeights(wrapper);
		});

	    splide.mount();

        // External controls
        if (relprevBtn) { relprevBtn.addEventListener('click', () => splide.go('<')); }
        if (relnextBtn) { relnextBtn.addEventListener('click', () => splide.go('>')); }
    });

	if (document.querySelector('#ethnicity')) {
		new SlimSelect({
	    	select: '#ethnicity',
	    	settings: {
			    placeholderText: 'Please choose...',
			    showSearch: false,
		  	}
	  	});
	}

	if (document.querySelector('#metric-ethnicity')) {
		new SlimSelect({
	    	select: '#metric-ethnicity',
	    	settings: {
			    placeholderText: 'Please choose...',
			    showSearch: false,
		  	}
	  	});
	}

	if (document.querySelector('#cat')) {
	  	new SlimSelect({
	    	select: '#cat',
	    	settings: {
			    placeholderText: 'Select an arcicle topic',
			    showSearch: false,
		  	}
	  	});
	}

	if (document.querySelector('#archives-dropdown-2')) {
	  	new SlimSelect({
	    	select: '#archives-dropdown-2',
	    	settings: {
			    placeholderText: 'Choose a month',
			    showSearch: false,
		  	}
	  	});
	}

	const promo = document.getElementById("se_promo");
	const promo_cta = document.getElementById("se_promo_cta");
	const dismiss = document.getElementById("close_promo");

	if (promo) {

	  	// Check if session cookie exists
	  	const isDismissed = sessionStorage.getItem("promoDismissed") === "true";

	  	if (!isDismissed) {

	    	const onScroll = function () {
	      		const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
	      		const scrollTop = window.scrollY || document.documentElement.scrollTop;
	      		const scrollPercent = (scrollTop / scrollHeight) * 100;

	      		if (scrollPercent >= 20) {
	      			document.body.classList.add('promo_active');
	        		promo.classList.add("active");
	        		document.removeEventListener("scroll", onScroll);
	      		}	
	    	};

	    	document.addEventListener("scroll", onScroll);

	    	if (dismiss) {
	      		dismiss.addEventListener("click", function () {
	      			document.body.classList.remove("promo_active");
	    			promo.classList.remove("active");
	        		sessionStorage.setItem("promoDismissed", "true"); // mark as dismissed
	        		document.removeEventListener("scroll", onScroll);
	      		});
			}

			if (promo_cta) {
	      		promo_cta.addEventListener("click", function () {
	      			document.body.classList.remove("promo_active");
	    			promo.classList.remove("active");
	        		sessionStorage.setItem("promoDismissed", "true"); // mark as dismissed
	        		document.removeEventListener("scroll", onScroll);
	      		});
			}

	  	} else {
	    	// Already dismissed this session, hide promo
	    	document.body.classList.remove("promo_active");
	    	promo.classList.remove("active");
	  	}
	}

});
